import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Row, Col } from 'antd';
import {
  TopHeaderBackground,
  TopHeaderContainer,
  DropdownAccountID,
  ElementContainer,
  SelectContainer,
  SelectOptionContainer,
  DropdownAmount,
  DropdownAccountName,
  AssistanceContainer,
  ProfileContainer,
  ProfileDropdownNew,
  MenuDropDown,
  ParentList,
  HeadingChild,
  BodyChild,
  MenuDropDownMSG,
  ViewAllUpdate,
  MessagingDiv,
  MessageBody,
  MsgLinkTo,
  NavMenuItem
} from './style';
import history from '../../../../history/history';
import { Link } from 'react-router-dom';
import NeedAssistancePage from '../NeedAssistance/NeedAssistance';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { showAssistanceComponent } from '../NeedAssistance/action';
import { Divider } from 'antd';
import { FixedWidth, JustifyBetween } from '../../../commonStyles';
import profile from '../../../../assets/icons/profile-1.svg';
import messagesIcon from '../../../../assets/icons/messages.svg';
import {
  getAccountData,
  getPrimaryAccount,
  checkPrimaryAcc,
  setPrimaryAccount,
  decryptAccountNumber,
  updateFundName,
  isGeminiUser,
  getTokenInfo  
} from '../../../../utils/sessionUtil';
import {clearReducerForOpenAdditionalAccount,fetchAlertForOAA} from '../../../../Epics/NPA/Pages/actions';
import {
  accountChange,
  selectHeader,
  changeAccountStatus,
  availableBalance,
  primaryAccountChanged,
  fetchCodeValueMapping,
  resetStepperIndex
} from '../../../../actions/globalActions';
import {
  fetchMessage,
  messageTabChange,
  fetchAllMessage,
  storeMessage,
  messageFullDisplayInitial
} from '../../../../Epics/Messaging/action';
import { getBaseUrl, todayDate, initiateTracking, recordError } from '../../../../utils/commonUtil';
import Preloader from '../../../Preloader/Preloader';
import _ from 'lodash';
import { AlertPopUpPrimary } from '../../../../Epics/NPA/Pages/Step1Setup/styles.js';
import { resetEnableBack } from '../../../../Epics/FinancialAdvisor/action';
import { getAlert } from '../../../../Epics/NPA/Pages/Step1Setup/Components/UtilFunctions';
import { HeaderDerivedStates } from "../../selectors";
import { logOut } from '../../../../Auth0/SessionProvider';
import { resetContribution } from '../../../../Epics/Contributions/Pages/ContributionActivity/actions';

class TopHeader extends Component {
  state = {
    selectedOption: { accountID: '' },
    options: [],
    openMessage: false,
    visible: false,
    drawerCondition: true,
    profileDropdown: false,
    accountCounter: 0,
    accountStatus: false,
    fundNameStatusUsedForNPA: false,
    fundNameStatusUsedForNPACounter: 0,
    modalAdditionalAcc: false,
    openAdditionalAlert: []
  };

  componentDidMount(){    
    this.props.fetchAlertForOAA();
  }

  componentWillMount() {    
    getTokenInfo();    
    this.updateSelectDropDown();
    this.fetchMessageApi();
    this.fetchCodeValueMapping();
  }

  componentDidUpdate(oldProps) {
    if (this.props.fundNameUsedForNPAStatus) {
      if (this.state.fundNameStatusUsedForNPACounter === 0) {
        let counter = this.state.fundNameStatusUsedForNPACounter;
        counter += 1;
        this.setState({ fundNameStatusUsedForNPACounter: counter });
      }
    }
    if (oldProps.accountID !== this.props.accountID) {
      if (this.props.account.status) {
        this.setState({ accountStatus: this.props.account.status }, () => {
          this.handleChange(this.props.accountID, '', 'OAA');
          this.props.changeAccountStatus();
          this.setState({accountStatus:false});
        });
      } else {
        this.handleChange(this.props.accountID);
      }
    }
    if (oldProps.defaultFund !== this.props.defaultFund) {
      if (!this.props.fundNameUsedForNPAStatus) {
        updateFundName(this.props.defaultFund);
        this.updateSelectDropDown();
      } else {
        this.updateSelectDropDown();
      }
    }
  }

  updateSelectDropDown() {
    let accData = getAccountData();
    let accountSelected;
    if(accData.Accounts){
      let newAccData = accData.Accounts.map((item, i) => {
        for (let key in item) {
          if (
            key !== 'role' &&
            key !== 'accountName' &&
            key !== 'currentBalance' &&
            key !== 'accountType' &&
            key !== 'freezes'
          ) {
            if (process.env.REACT_APP_NODE_ENV === 'development') {
              // code Local
              item.accountNumber = key;
              item.userId = item[key];
            } else {
              //code SIT UAT
              item.accountNumber = decryptAccountNumber(key);
              item.userId = item[key];
            }

            if (item.userId === accData.PrimaryAccountForParty) {
              if (!checkPrimaryAcc()) {
                accountSelected = { accountID: item.userId };
                setPrimaryAccount(item);
              } else {
                accountSelected = { accountID: checkPrimaryAcc().userId };
              }
            }
          }
        }
        return item;
      });

      this.setState({
        options: newAccData,
        selectedOption: accountSelected
      });
    }
  }
  componentWillReceiveProps(newprops) {
    if (
      (this.props.isMessageLoaded !== newprops.isMessageLoaded &&
        !newprops.isMessageLoaded) ||
      (this.props.isAllMessageLoaded !== newprops.isAllMessageLoaded &&
        !newprops.isAllMessageLoaded)
    ) {
      let allmessages = [...newprops.messagesData, ...newprops.allmessagesData];
      allmessages.sort(this.sort_date);
      this.storeState(allmessages);
    }
  }

  fetchCodeValueMapping() {
    this.props.fetchCodeValueMapping({
      metaData: {
        method: `GET`,
        url: `/donor-portal/api/dropDownValues/getCodeValueMapping`
      }
    })
  }
  storeState = msg => {
    this.props.storeMessage(msg);
  };
  fetchMessageApi() {
    this.props.fetchMessage({
      messagingData: {
        method: 'GET',
        url: `/dp-messages?Account=${
          getPrimaryAccount().accountType
        }`,
        page: 'messaging',
        isExternal: true
      },
      additionalAccountDetails: {
        method: 'GET',
        url: `${getBaseUrl()}/donor-portal/api/account/${
          getPrimaryAccount().userId
        }/findAdditionalAccountDetails${isGeminiUser() ? `?partyId=${getAccountData().partyId}`: ''}`,
        page: 'messaging',
        isExternal: true
      }
    });
    this.props.fetchAllMessage({
      method: 'GET',
      url: `/dp-allmessages`,
      page: 'messaging',
      isExternal: true
    });
  }

  goToRoute(link, SelectName = '') {
    if (SelectName !== '') {
      this.props.selectHeader(SelectName);
    }
    if (this.state.modalAdditionalAcc) {
      this.setState({ modalAdditionalAcc: false });
    }
    history.push(link);
  }

  hideModal = () => {
    this.setState({ modalAdditionalAcc: false });
  };

  getAvailableBalance = () => {
    this.props.getAvailableBalance({
      metaData: [
        {
          method: "GET",
          url: `/donor-portal/api/account/${
            getPrimaryAccount().userId
          }/findSummary/${getAccountData().partyId}?startDate=10/04/1970&endDate=${todayDate()}`,
        },
      ],
    })
  }

  handleChange(e,element = '',type = ''){
    let isBack = this.props.enableBack;
    if (e === 'OPA') {
      this.setState({ modalAdditionalAcc: true });
    } else {
      const { onAccountChange } = this.props;
      const selectedAcc = { ...this.state.selectedOption };
      const accData = getAccountData();
      let newAccData = accData.Accounts.map(item => {
        for (let key in item) {
          if (
            key !== 'role' &&
            key !== 'accountName' &&
            key !== 'currentBalance' &&
            key !== 'accountType' &&
            key !== 'freezes'
          ) {
              if (process.env.REACT_APP_NODE_ENV === 'development') {
                // code local
                item.accountNumber = key;
                item.userId = item[key];
              } else {
                // code SIT UAT
                item.accountNumber = decryptAccountNumber(key);
                item.userId = item[key];
              }
            if (item[key] === e) {
              const restorer = JSON.parse(sessionStorage.getItem('primaryAccount'));
              setPrimaryAccount(item);
              if (type === '' && !this.state.accountStatus) {
                if (item.accountName !== restorer.accountName) {
                  this.goToRoute('/', 'ACCOUNT SUMMARY');
                }
              }
              this.getAvailableBalance();
            }
          }
        }
        if (type !== '' && this.state.accountStatus) {
          return item;
        }
      });

      selectedAcc.accountID = e;
      if (type !== '' && this.state.accountStatus) {
        this.setState({ options: newAccData });
      }
      this.setState({ selectedOption: selectedAcc }, () => {
        onAccountChange(selectedAcc);
        this.props.resetContribution();
      });
      this.fetchMessageApi();
    }
  };

  handleMessage = () => {
    this.setState({
      openMessage: !this.state.openMessage
    });
  };

  handleAssistance = () => {
    this.setState({
      visible: true
    });
  };

  submitHandler = inputValues => {
    this.setState({
      drawerCondition: false
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
    let self = this;
    setInterval(function() {
      self.setState({
        drawerCondition: true
      });
    }, 2000);
  };
  handleTabChange(tid) {
    try {
      this.props.messageTabChange(tid);
      this.props.messageFullDisplayInitial();
      sessionStorage.setItem("messagingTid", tid)
      this.props.selected === "MessagesFalse" ? this.props.selectHeader("MessagesTrue"):this.props.selectHeader("MessagesFalse");
      history.push({
        pathname: '/messages'
      });
    } catch (error) {
      recordError(error);
    }
  }
  alterDropdown() {
    this.setState({ profileDropdown: !this.state.profileDropdown });
  }
  logout = () => {
    if(!isGeminiUser()) {
      logOut('sessionTimeOut');
    }
  };

  sort_date = (a, b) => {
    return parseInt(b.changed_1) - parseInt(a.changed_1);
  };

  checkOrganizationEntity = () => {
    const { navBarData } = this.props;
    return navBarData && navBarData.entityType.toLowerCase() === 'organization';
  }

  checkNoWebAccess = () => {
    const { navBarData } = this.props;
    return navBarData && !navBarData.webAccess && navBarData.isPrimaryAccountDonorOnly
  }
  
  backToDashboardHandler = () => {
    const financialPrimaryAcc = JSON.parse(sessionStorage.getItem('financialAdvisorPrimaryAccount'));
    sessionStorage.setItem('primaryAccount', JSON.stringify(financialPrimaryAcc));
    sessionStorage.removeItem('financialAdvisorPrimaryAccount');
    sessionStorage.removeItem('enableBack');
    this.props.accountChanged(financialPrimaryAcc.userId);    
    this.goToRoute('/financialadvisor');
  }

  analyticsTracking = (linkName,statusForMsg = true) => {
    try {
      initiateTracking('navigationDP', 'Navigation', 'Top Header Navigation DP',  linkName);
      switch (linkName) {
        case 'Need Assistance':
          this.props.onDrawerClick();
          break;
        case 'Open additional account':
          this.props.clearReducerForOpenAdditionalAccount();
          this.props.resetStepperState();
          this.goToRoute('/open-an-additional-account/account-information/');
          break;
        case 'Messages':
          if(statusForMsg){
            let { combinedMessagesData } = this.props;
            this.handleTabChange(
              combinedMessagesData[0] && combinedMessagesData[0].tid ? combinedMessagesData[0].tid : 0
            );
          }
          break;
        case 'Profile Logo - Logout': 
          this.logout();
          break;
      }
    } catch (error) {
      recordError(error);
    }    
	};

  render() {
    const { selectedOption, options, openAdditionalAlert } = this.state;
    const {  combinedMessagesData, alertOOA } = this.props;

    let sortedOption = _.orderBy(
      options,
      [user => user.accountName && user.accountName.toLowerCase()],
      ['asc']
    );
    sortedOption.push({
      userId: 'OPA',
      accountName: '+ Open additional account',
      disabled: isGeminiUser()
    });

    const msg = (
      <MenuDropDownMSG>
        <MessagingDiv>
          {combinedMessagesData &&
            combinedMessagesData.slice(0, 4).map((msgs, i) => (
              <ParentList key={i}>
                <HeadingChild>{msgs.changed}</HeadingChild>
                <BodyChild>
                  <span dangerouslySetInnerHTML={{__html: msgs.name}}></span>
                </BodyChild>
                <JustifyBetween>
                  <MessageBody>
                    <span dangerouslySetInnerHTML={{__html: msgs.field_message_body}}></span>
                  </MessageBody>
                  <MsgLinkTo onClick={() => this.handleTabChange(msgs.tid)}>
                    Read More{' '}
                  </MsgLinkTo>
                </JustifyBetween>
                {combinedMessagesData.slice(0, 4).length - 1 === i ? (
                  ''
                ) : (
                  <Divider />
                )}
              </ParentList>
            ))}
            {(this.props.isMessageLoaded && this.props.isAllMessageLoaded) &&
              <div>
               <Preloader />
             </div>
            }
            {combinedMessagesData && (combinedMessagesData.length < 1) && !this.props.isMessageLoaded && !this.props.isAllMessageLoaded &&
              <>You currently have no News & Updates.</>
            }
        </MessagingDiv>
        {((combinedMessagesData && (combinedMessagesData.length > 1)) && (!this.props.isMessageLoaded || !this.props.isAllMessageLoaded)) &&
        <ViewAllUpdate>
          <MsgLinkTo
            onClick={() => {
              this.handleTabChange(combinedMessagesData[0]&&combinedMessagesData[0].tid ?combinedMessagesData[0].tid : 0);
            }}
          >
            View all messages
          </MsgLinkTo>
        </ViewAllUpdate>
        }
      </MenuDropDownMSG>
    );

    // From Gemini - check the call from 'Organization' entity
    const isOrganization = this.checkOrganizationEntity();
    // Check user is not web registerd and only one primary account donor 
    const isNotWebAccess = this.checkNoWebAccess();

    const menu = (
      <MenuDropDown selectedKeys={[this.props.current === 'My Profile' ? '0' : '2']}>
        <NavMenuItem key='0' className={isGeminiUser() && isOrganization || isNotWebAccess ? 'not-allowed-cursor' : ''}>
          <Link to='/my-profile' data-test="myprofile-logo" onClick={() => this.analyticsTracking('Profile Logo - My Profile')} disabled={isGeminiUser() && isOrganization || isNotWebAccess}>My Profile</Link>
        </NavMenuItem>
        <NavMenuItem key='1' className={isGeminiUser() ? 'not-allowed-cursor' : ''}>
          <a disabled={ isGeminiUser() ? true : false } onClick={() => this.analyticsTracking('Profile Logo - Logout')}>Logout</a>
        </NavMenuItem>
      </MenuDropDown>
    );

    if(alertOOA && alertOOA.length && !openAdditionalAlert.length){
      this.setState({
        openAdditionalAlert: getAlert(alertOOA,'Alert')
      });
    }
    return (
      <TopHeaderBackground data-test="topheader-section">
        <p
          style={{
            display: 'none'
          }}
        >
          {this.props.accountChangedOnfinacialAdvisor}
        </p>
        {this.state.modalAdditionalAcc && (
          <>
            <AlertPopUpPrimary
              data-test="alert-popup-OPA"
              title={(openAdditionalAlert.length && openAdditionalAlert[0].field_header) || 'Alert'}
              visible={this.state.modalAdditionalAcc}
              width='580px'
              onOk={() => this.analyticsTracking('Open additional account')}
              onCancel={this.hideModal}
              cancelText={(openAdditionalAlert.length && openAdditionalAlert[0].field_alert_button2_text) || 'close'}
              okText={(openAdditionalAlert.length && openAdditionalAlert[0].field_alert_button1_text) || 'CONTINUE'}
            >
              {(openAdditionalAlert.length && <span dangerouslySetInnerHTML = {{__html : openAdditionalAlert[0].field_description}}/>) || 
                <>Your existing account information will pre-fill the following
                profile screen. Any changes made to your personal information will
                overwrite your profile throughout the website.
                <br />
                Although you must be an account advisor on any account you open,
                you will have the option to add a second advisor.</>
              }
            </AlertPopUpPrimary>
          </>
        )}
        <FixedWidth>
          <TopHeaderContainer>
            <ElementContainer>
              {
                isGeminiUser() ? 
                <AssistanceContainer className='not-allowed-cursor'>
                  Need Assistance?
                </AssistanceContainer> :
                <AssistanceContainer data-test="need-assistance-container" onClick={() => this.analyticsTracking('Need Assistance')}>
                  Need Assistance?
                </AssistanceContainer>
              }
              <NeedAssistancePage />
              <div className="topHeader-dropDown">
                <SelectContainer
                  dropdownClassName='account-dd-overlay'
                  defaultValue={
                    this.props.accountChangedOnfinacialAdvisor ||
                    selectedOption.accountID
                  }
                  onChange={this.handleChange.bind(this)}
                  value={selectedOption.accountID}
                  title={
                    selectedOption.accountNumber +
                    ' - ' +
                    selectedOption.accountName
                  }
                  className='account-dropdown'
                  aria-label="account-select"
                  role={false}
                >
                  {sortedOption.map((data, i) => (
                    <SelectOptionContainer
                      key={data.userId}
                      value={data.userId}
                      disabled={data.disabled}
                      className={
                        data.userId === selectedOption.accountID
                          ? 'selected-blue'
                          : null
                      }
                    >
                      <DropdownAccountName
                        className=' '
                        title={data.accountName}
                      >
                        {data.accountName}
                      </DropdownAccountName>
                      {data.accountNumber && (
                        <DropdownAccountID className=''>
                          {data.accountNumber}
                        </DropdownAccountID>
                      )}

                      {i < sortedOption.length - 1 &&
                        data.currentBalance === 0 && (
                          <DropdownAmount className=' '>$0.00</DropdownAmount>
                        )}
                      {i < sortedOption.length - 1 && data.currentBalance !== 0 && (
                        <DropdownAmount>
                          {'$' +
                            Number(data.currentBalance).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            )}
                        </DropdownAmount>
                      )}
                    </SelectOptionContainer>
                  ))}
                </SelectContainer>
              </div>
              <div>
                <Row>
                  <Col span xs={24} md={0} lg={0}>
                    <img
                      data-test="msg-icon"
                      src={messagesIcon}
                      alt='messagesIcon'
                      onClick={() => {
                        this.analyticsTracking('Messages')
                      }}
                    />
                  </Col>
                </Row>
                <ProfileDropdownNew
                  data-test="profile-dropdown"
                  overlay={msg}
                  overlayClassName='submenu-fixed'
                  placement='bottomRight'
                  trigger={['click']}
                  onVisibleChange = {(visible) => { visible && this.analyticsTracking('Messages',false) }}
                >
                  <a className='ant-dropdown-link' href='#' aria-label="drop down">
                    <Row>
                      <Col span xs={0} md={24} lg={24}>
                        <img
                          src={messagesIcon}
                          alt='messagesIcon'
                          className='profileIcon'
                        />
                      </Col>
                    </Row>
                  </a>
                </ProfileDropdownNew>
              </div>
              <ProfileContainer>
                <ProfileDropdownNew
                  data-test="profile-dropdown-link"
                  overlay={menu}
                  overlayClassName='submenu-fixed'
                  placement='bottomRight'
                  trigger={['click']}
                >
                  <a className='ant-dropdown-link' href='#'>
                    <img src={profile} alt='profile' className='profileIcon' />
                  </a>
                </ProfileDropdownNew>
              </ProfileContainer> 
            </ElementContainer>
          </TopHeaderContainer>
        </FixedWidth>
      </TopHeaderBackground>
    );
  }
}

TopHeader.propTypes = {
  account: PropTypes.shape({
    status: PropTypes.any
  }),
  accountChanged: PropTypes.func,
  accountChangedOnfinacialAdvisor: PropTypes.any,
  accountID: PropTypes.any,
  alertOOA: PropTypes.shape({
    length: PropTypes.any
  }),
  allmessagesData: PropTypes.any,
  changeAccountStatus: PropTypes.func,
  clearReducerForOpenAdditionalAccount: PropTypes.func,
  combinedMessagesData: PropTypes.any,
  current: PropTypes.string,
  defaultFund: PropTypes.any,
  enableBack: PropTypes.any,
  fetchAlertForOAA: PropTypes.func,
  fetchAllMessage: PropTypes.func,
  fetchCodeValueMapping: PropTypes.func,
  fetchMessage: PropTypes.func,
  fundNameUsedForNPAStatus: PropTypes.any,
  getAvailableBalance: PropTypes.func,
  isAllMessageLoaded: PropTypes.any,
  isMessageLoaded: PropTypes.any,
  messageFullDisplayInitial: PropTypes.func,
  messageTabChange: PropTypes.func,
  messagesData: PropTypes.any,
  navBarData: PropTypes.shape({
    entityType: PropTypes.any,
    isPrimaryAccountDonorOnly: PropTypes.any,
    webAccess: PropTypes.any
  }),
  onAccountChange: PropTypes.func,
  onDrawerClick: PropTypes.func,
  resetStepperState: PropTypes.func,
  selectHeader: PropTypes.func,
  selected: PropTypes.string,
  storeMessage: PropTypes.func
}

export const mapStateToProps = state => {
  return {
  ...HeaderDerivedStates(state.toJS())
  };
};

export const mapDispatchToProps = dispatch => ({
  messageTabChange: data => dispatch(messageTabChange(data)),
  onDrawerClick: () => dispatch(showAssistanceComponent()),
  onAccountChange: data => dispatch(accountChange(data)),
  selectHeader: data => dispatch(selectHeader(data)),
  fetchMessage: data => dispatch(fetchMessage(data)),
  fetchAllMessage: data => dispatch(fetchAllMessage(data)),
  storeMessage: data => dispatch(storeMessage(data)),
  changeAccountStatus: () => dispatch(changeAccountStatus()),
  messageFullDisplayInitial: () => dispatch(messageFullDisplayInitial()),
  getAvailableBalance: (data) => dispatch(availableBalance(data)),
  resetEnableBack: () => dispatch(resetEnableBack()),
  accountChanged: data => dispatch(primaryAccountChanged(data)),
  fetchCodeValueMapping: data => dispatch(fetchCodeValueMapping(data)),
  clearReducerForOpenAdditionalAccount: () => dispatch(clearReducerForOpenAdditionalAccount()),
  resetStepperState: () => dispatch(resetStepperIndex()),
  fetchAlertForOAA: () => dispatch(fetchAlertForOAA()),
  resetContribution: () => dispatch(resetContribution())
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TopHeader)
);
